/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons';
import Button from 'components/Button';
import { CompanyFieldsProps } from 'components/SelectCompany';
import CompanyList from 'components/SelectCompany/companyList';
import { Formik } from 'formik';
import { Query } from 'hooks/useTableFilters';
import i18n from 'i18n';
import { CompanyData } from 'modules/authenticate/interfaces';
import { modalClose } from 'modules/modal/actions';
import { clonePartnerRequest } from 'modules/partners/actions';
import { AllPartnersFields, PartnerFields } from 'modules/partners/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import GenericForm from 'skyone-lib/lib/GenericForm';
import ApplicationState from 'store/interfaces';
import validationSchema from './schema';
import styles from './styles';

const useStyles = makeStyles(styles);

interface FormClonePartnerProps {
  companySelected: CompanyData | null;
  partner: PartnerFields | AllPartnersFields;
  query: Query;
  clonePartnerRequest: ({ partnerUuid, values, company_uuid, query }) => void;
  modalClose: () => void;
}

const initialValues = {
  name: '',
  company_uuid: '',
};

export const FormClonePartner = ({
  companySelected,
  partner,
  query,
  clonePartnerRequest,
  modalClose,
}: FormClonePartnerProps) => {
  const classes = useStyles();
  const [
    companyFields,
    setCompanyFields,
  ] = React.useState<CompanyFieldsProps | null>(null);

  const handleSubmit = (values: typeof initialValues) => {
    clonePartnerRequest({
      partnerUuid: partner?.partner_uuid,
      company_uuid: companySelected?.id,
      values,
      query,
    });
    modalClose();
  };

  return (
    <Grid item container>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ setFieldValue, errors, values, submitForm }) => (
          <Grid container spacing={2}>
            <GenericForm
              fields={values}
              screenFields={[
                {
                  gridXs: 12,
                  label: i18n.t('PARTNER_PAGE.CLONE_PARTNER_NAME_KEY'),
                  stateKey: 'name',
                },
              ]}
              errors={errors}
              setFieldValue={setFieldValue}
            />

            <Grid item xs={12}>
              <CompanyList
                companyFields={companyFields}
                stateKey="company_uuid"
                setCompanyFields={setCompanyFields}
                setFieldValue={setFieldValue}
              />
            </Grid>

            <Grid
              container
              justify="space-between"
              className={classes.buttonsBase}
            >
              <Grid item xs={8}>
                <Typography className={classes.observationText}>
                  <InfoOutlinedIcon color="primary" fontSize="small" />
                  {i18n.t('PARTNER_PAGE.CLONE_PARTNER_OBSERVATION_KEY')}
                </Typography>
              </Grid>
              <Grid item xs={4} className={classes.buttonsAlign}>
                <Button id="submit-button" submitButton onClick={submitForm}>
                  {i18n.t('CLONE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected },
}: ApplicationState) => ({
  companySelected,
});

export default connect(mapStateToProps, {
  clonePartnerRequest,
  modalClose,
})(FormClonePartner);
